// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1vub_","tab":"Tabs_tab__3mD-4","tabActive":"Tabs_tabActive__rDGoZ"};